import { requestEncode } from "@/apis/common_api";

const state = {
  loadingState: false
};

const getters = {
  getloadingState(state) {
    return state.loadingState;
  }
};

const mutations = {
  START_LOADING(state) {
    state.loadingState = true;
  },
  END_LOADING(state) {
    setTimeout(() => {
      state.loadingState = false;
    }, 1000);
  }
};

const actions = {
  async REQUEST_ENCODE({ commit }, parameter) {
    const resultParam = { result: false };

    try {
      commit("START_LOADING");
      const response = await requestEncode(parameter);

      if (response.data?.result === "success") {
        resultParam.str = response.data.encodeStr;
        resultParam.result = true;
      } else {
        alert(response.data?.message || "인코딩 실패");
      }
    } catch (e) {
      if (e === "refresh") {
        return;
      }
    } finally {
      commit("END_LOADING");
    }

    return resultParam;
  }
};

export default { mutations, state, actions, getters };
